// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExperimentFilledSvg from "@ant-design/icons-svg/es/asn/ExperimentFilled";
import AntdIcon from '../components/AntdIcon';

var ExperimentFilled = function ExperimentFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentFilledSvg
  }));
};

ExperimentFilled.displayName = 'ExperimentFilled';
export default React.forwardRef(ExperimentFilled);